import { computed } from 'vue'

import { storeToRefs } from 'pinia'

import * as aggr from '@/api-generator/aggr'
import appStore from '@/stores'

// 確認當前方案權限
export const useCheckPlanFeatures = () => {
  const { companyPlanFeatures } = storeToRefs(appStore.useFECompanyStore)

  const hasPermission = (featureCode: aggr.PROMFeatures) => {
    const feature = companyPlanFeatures.value.find((feat) => feat.feature === featureCode)
    return feature ? feature.enable : false
  }

  const canDownLoadChart = computed(() => hasPermission(aggr.PROMFeatures.ChartDownload))
  const canExportCSV = computed(() => hasPermission(aggr.PROMFeatures.ReportExport))
  const canBatchCreateShortUrls = computed(() => hasPermission(aggr.PROMFeatures.BatchShortUrlCreation))
  const canUseGtmDataIntegration = computed(() => hasPermission(aggr.PROMFeatures.GtmDataIntegration))
  const canViewDataOverlapAnalysis = computed(() => hasPermission(aggr.PROMFeatures.DataOverlapAnalysis))

  // 未使用的權限
  // const canUseOrgUrlSortTag = computed(() => hasPermission(aggr.PROMFeatures.UrlCategoryLabel))
  // const canViewOrgTagDataComparison = computed(() => hasPermission(aggr.PROMFeatures.OrganizationTagDataComparison))

  return {
    canDownLoadChart,
    canExportCSV,
    canBatchCreateShortUrls,
    canUseGtmDataIntegration,
    canViewDataOverlapAnalysis
  }
}
